import React from "react";
import { default as MUICardActionArea } from "@mui/material/CardActionArea";
import styled from "styled-components";

const StyledMUICardActionArea = styled(MUICardActionArea)`
  :hover {
    background-color: #fff;
    color: inherit;
  }
`;

export const CardActionArea = (props) => {
  return <StyledMUICardActionArea {...props} />;
};
